import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  buildApplicantPayload,
  buildCraQuestionPayload,
  buildPersonCheckboxPayload,
  createPerson,
  createTaxSession,
  saveCraQuestions,
  savePersonCheckboxes,
  updatePerson,
} from "./submissionFlow";

// Helper for dynamic dependents
const getDependents = (count: number) =>
  Array.from({ length: count }, (_, i) => `dependent${i + 1}`);

const TABS = ["Primary applicant", "Spouse"];

const SECTION_LABELS = [
  "Tax payer's primary information",
  "Situation on December 31, 2026",
  "Mailing address and residence information",
  "CRA questions",
  "Email notifications from CRA",
  "Specific situations",
  "Employment and other benefits",
  "Self employment",
  "Common tax deductions",
  "Parents & children",
  "Installments & tax transfer",
  "Carry forward amounts & prior year information",
  "Other topics",
  "Other income",
  "Other information slips",
];

const initialPersonData = {
  designation: "",
  firstName: "",
  role: "",
  lastName: "",
  dob: "",
  changeOfName: "",
  sin: "",
  province: "",
  maritalStatus: "",
  maritalStatusChange: "",
  gender: "",
  dependantsBelow18: "0",
  dependantHadIncome: "",
  apartmentNumber: "",
  streetNumber: "",
  postOfficeBoxNumber: "",
  ruralRoute: "",
  city: "",
  provinceOrTerritory: "",
  sameAddyAspouse: "",
  postalCode: "",
  careOf: "",
  dom: "",
  mailingOrHome: "",
  homePhone: "",
  workPhone: "",
  cellPhone: "",
  currProvince: "",
  // Page2 fields
  corrLanguage: "",
  firstTimeFiler: "",
  forProperty: "",
  sellPrincipalResidence: "",
  diplomat: "",
  canadianCitizenship: "",
  authorizeCra: "",
  consentToShare: "",
  acceptTerms: "",
  emailAddress: "",
  emailConfirmation: "",
  // Checkbox sections (Page3–Page6)
  // Page3: Specific situations
  specificSituation1: false,
  specificSituation2: false,
  specificSituation3: false,
  specificSituation4: false,
  specificSituation5: false,
  specificSituation6: false,
  specificSituation7: false,
  specificSituation8: false,
  specificSituation9: false,
  specificSituation10: false,
  specificSituation11: false,
  specificSituation12: false,
  specificSituation13: false,
  specificSituation14: false,
  specificSituation15: false,
  specificSituation16: false,
  specificSituation17: false,
  specificSituation18: false,
  // Page3: Employment and other benefits
  employment1: false,
  employment2: false,
  employment3: false,
  employment4: false,
  employment5: false,
  employment6: false,
  employment7: false,
  employment8: false,
  employment9: false,
  employment10: false,
  employment11: false,
  employment12: false,
  employment13: false,
  employment14: false,
  employment15: false,
  employment16: false,
  employment17: false,
  employment18: false,
  employment19: false,
  employment20: false,
  employment21: false,
  employment22: false,
  employment23: false,
  employment24: false,
  // Page4: Pension, rental, investment (IDs from Page4)
  pension1: false,
  pension2: false,
  pension3: false,
  pension4: false,
  pension5: false,
  pension6: false,
  pension7: false,
  pension8: false,
  pension9: false,
  rental1: false,
  investment1: false,
  investment2: false,
  investment3: false,
  investment4: false,
  investment5: false,
  investment6: false,
  investment7: false,
  investment8: false,
  investment9: false,
  investment10: false,
  investment11: false,
  investment12: false,
  investment13: false,
  investment14: false,
  investment15: false,
  investment16: false,
  investment17: false,
  investment18: false,
  investment19: false,
  investment20: false,
  investment21: false,
  investment22: false,
  investment23: false,
  investment24: false,
  investment25: false,
  investment26: false,
  investment27: false,
  // Page5: Self employment
  selfEmploymentOption1: false,
  selfEmploymentOption2: false,
  selfEmploymentOption3: false,
  selfEmploymentOption4: false,
  selfEmploymentOption5: false,
  selfEmploymentOption6: false,
  selfEmploymentOption7: false,
  selfEmploymentOption8: false,
  selfEmploymentOption9: false,
  selfEmploymentOption10: false,
  selfEmploymentOption11: false,
  selfEmploymentOption12: false,
  selfEmploymentOption13: false,
  selfEmploymentOption14: false,
  selfEmploymentOption15: false,
  selfEmploymentOption16: false,
  selfEmploymentOption17: false,
  selfEmploymentOption18: false,
  selfEmploymentOption19: false,
  selfEmploymentOption20: false,
  selfEmploymentOption21: false,
  selfEmploymentOption22: false,
  selfEmploymentOption23: false,
  selfEmploymentOption24: false,
  selfEmploymentOption25: false,
  selfEmploymentOption26: false,
  selfEmploymentOption27: false,
  // Page5: Common tax deductions
  taxDeductionOption1: false,
  taxDeductionOption2: false,
  taxDeductionOption3: false,
  taxDeductionOption4: false,
  taxDeductionOption5: false,
  taxDeductionOption6: false,
  taxDeductionOption7: false,
  taxDeductionOption8: false,
  taxDeductionOption9: false,
  taxDeductionOption10: false,
  taxDeductionOption11: false,
  taxDeductionOption12: false,
  taxDeductionOption13: false,
  taxDeductionOption14: false,
  taxDeductionOption15: false,
  taxDeductionOption16: false,
  taxDeductionOption17: false,
  taxDeductionOption18: false,
  taxDeductionOption19: false,
  taxDeductionOption20: false,
  taxDeductionOption21: false,
  taxDeductionOption22: false,
  taxDeductionOption23: false,
  taxDeductionOption24: false,
  taxDeductionOption25: false,
  taxDeductionOption26: false,
  taxDeductionOption27: false,
  taxDeductionOption28: false,
  taxDeductionOption29: false,
  taxDeductionOption30: false,
  taxDeductionOption31: false,
  taxDeductionOption32: false,
  // Page5: Parents & children
  parentsChildrenOption1: false,
  parentsChildrenOption2: false,
  parentsChildrenOption3: false,
  parentsChildrenOption4: false,
  parentsChildrenOption5: false,
  parentsChildrenOption6: false,
  parentsChildrenOption7: false,
  parentsChildrenOption8: false,
  parentsChildrenOption9: false,
  parentsChildrenOption10: false,
  // Page5: Installments & tax transfer
  installmentsTaxTransferOption1: false,
  // Page6: Carry forward amounts & prior year information
  carryForwardOption1: false,
  carryForwardOption2: false,
  carryForwardOption3: false,
  carryForwardOption4: false,
  carryForwardOption5: false,
  carryForwardOption6: false,
  carryForwardOption7: false,
  carryForwardOption8: false,
  carryForwardOption9: false,
  carryForwardOption10: false,
  carryForwardOption11: false,
  // Page6: Other topics
  otherTopicOption1: false,
  otherTopicOption2: false,
  otherTopicOption3: false,
  otherTopicOption4: false,
  otherTopicOption5: false,
  otherTopicOption6: false,
  otherTopicOption7: false,
  otherTopicOption8: false,
  otherTopicOption9: false,
  otherTopicOption10: false,
  otherTopicOption11: false,
  otherTopicOption12: false,
  otherTopicOption13: false,
  otherTopicOption14: false,
  // Page6: Other income
  otherIncomeOption1: false,
  otherIncomeOption2: false,
  otherIncomeOption3: false,
  otherIncomeOption4: false,
  otherIncomeOption5: false,
  // Page6: Other information slips
  otherInfoSlipOption1: false,
  privacyPolicyAcknowledged: false,
  privacyPolicyReadDate: "",
  privacyPolicyFullName: "",
};

const extractCraQuestions = (person: any) => {
  return {
    corrLanguage: person.corrLanguage,
    firstTimeFiler: person.firstTimeFiler,
    forProperty: person.forProperty,
    sellPrincipalResidence: person.sellPrincipalResidence,
    diplomat: person.diplomat,
    canadianCitizenship: person.canadianCitizenship,
    authorizeCra: person.authorizeCra,
    consentToShare: person.consentToShare,
    acceptTerms: person.acceptTerms,
    emailAddress: person.emailAddress,
    emailConfirmation: person.emailConfirmation,
  };
};

const Home: React.FC = () => {
  // State for all people (primary, spouse, dependents)
  const [people, setPeople] = useState<{
    primary: typeof initialPersonData;
    spouse?: typeof initialPersonData;
    [key: string]: any;
  }>({
    primary: { ...initialPersonData },
  });

  const history = useHistory();
  const API_BASE = (
    process.env.REACT_APP_API_BASE || "http://localhost:8080"
  ).replace(/\/$/, "");

  const [formData, setFormData] = useState({
    designation: "",
    firstName: "",
    lastName: "",
    role: "",
    dob: "",
    changeOfName: "",
    sin: "",
    province: "",
    maritalStatus: "",
    maritalStatusChange: "",
    gender: "",
    dependantsBelow18: "",
    dependantHadIncome: "",
    apartmentNumber: "",
    streetNumber: "",
    postOfficeBoxNumber: "",
    ruralRoute: "",
    city: "",
    provinceOrTerritory: "",
    sameAddyAspouse: "",
    postalCode: "",
    careOf: "",
    dom: "",
    mailingOrHome: "",
    homePhone: "",
    workPhone: "",
    cellPhone: "",
    currProvince: "",
  });

  useEffect(() => {
    const storedData = localStorage.getItem("formData");
    setFormData(
      storedData
        ? JSON.parse(storedData)
        : {
            designation: "",
            firstName: "",
            lastName: "",
            role: "",
            dob: "",
            changeOfName: "",
            sin: "",
            province: "",
            maritalStatus: "",
            maritalStatusChange: "",
            gender: "",
            dependantsBelow18: "",
            dependentHadIncome: "",
            apartmentNumber: "",
            streetNumber: "",
            postOfficeBoxNumber: "",
            ruralRoute: "",
            city: "",
            provinceOrTerritory: "",
            sameAddyAspouse: "",
            postalCode: "",
            careOf: "",
            dom: "",
            mailingOrHome: "",
            homePhone: "",
            workPhone: "",
            cellPhone: "",
            currProvinceIfd: "",
          },
    );
  }, []);

  function dateCustomFormatting(date: string): string {
    const [year, month, day] = date.split("-");
    return `${year}-${month}-${day}`;
  }

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawDate = e.target.value;
    const formattedDate = dateCustomFormatting(rawDate);
    setFormData({ ...formData, dob: formattedDate });
  };

  // Handle field changes for each person
  const handleChange = (
    tab: string,
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value, type } = e.target;
    let checked: boolean | undefined = undefined;
    if (type === "checkbox" && e.target instanceof HTMLInputElement) {
      checked = e.target.checked;
    }
    // Determine the person key for the tab
    let personKey: string;
    if (tab === "Primary applicant") {
      personKey = "primary";
    } else if (tab === "Spouse") {
      personKey = "spouse";
    } else if (tab.startsWith("Dependent")) {
      // e.g. "Dependent 1"
      const depNum = tab.split(" ")[1];
      personKey = `dependent${depNum}`;
    } else {
      personKey = "primary";
    }
    setPeople((prev) => ({
      ...prev,
      [personKey]: {
        ...prev[personKey],
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  };

  const handleSubmit = () => {
    // Optionally save to localStorage
    localStorage.setItem("formData", JSON.stringify(formData));
    if (
      formData.maritalStatus === "Married" ||
      formData.maritalStatus === "Common-law"
    ) {
      history.push("/pg7");
    } else {
      history.push("/about");
    }
  };

  // Tabs
  const [activeTab, setActiveTab] = useState("Primary applicant");

  // Accordion state for sections
  // Change: Track openSections per tab so each tab's accordion state is independent
  const [openSections, setOpenSections] = useState<{
    [tab: string]: { [key: string]: boolean };
  }>({});

  // Helper to toggle accordion sections per tab
  const toggleSection = (section: string) =>
    setOpenSections((prev) => ({
      ...prev,
      [activeTab]: {
        ...(prev[activeTab] || {}),
        [section]: !prev[activeTab]?.[section],
      },
    }));

  // Get number of dependents from primary applicant
  const dependantsCount = parseInt(people.primary.dependantsBelow18 || "0", 10);
  const dependents = getDependents(dependantsCount);

  // Show spouse tab if married or common-law
  const showSpouse =
    people.primary.maritalStatus === "Married" ||
    people.primary.maritalStatus === "Common-law";

  // Tabs array
  const tabs = [
    "Primary applicant",
    ...(showSpouse ? ["Spouse"] : []),
    ...dependents.map((_, i) => `Dependent ${i + 1}`),
  ];

  // Section order for navigation
  const sectionOrder = [
    "Tax payer's primary information",
    "Situation on December 31, 2026",
    "Mailing address and residence information",
    "CRA questions",
    "Email notifications from CRA",
    "Specific situations",
    "Employment and other benefits",
    "Pension, rental, investment",
    "Self employment",
    "Common tax deductions",
    "Parents & children",
    "Installments & tax transfer",
    "Carry forward amounts & prior year information",
    "Other topics",
    "Other income",
    "Other information slips",
  ];

  // Track which section is currently being viewed for each tab
  const [currentSectionIdx, setCurrentSectionIdx] = useState<{
    [tab: string]: number;
  }>({
    "Primary applicant": 0,
  });

  // Helper to open only the current section for the active tab
  useEffect(() => {
    if (activeTab && currentSectionIdx[activeTab] !== undefined) {
      const currentSection = sectionOrder[currentSectionIdx[activeTab] ?? 0];
      if (currentSection) {
        setOpenSections((prev) => {
          // Only update if different from current state
          const currentValue = prev[activeTab]?.[currentSection];
          if (currentValue !== true) {
            return {
              ...prev,
              [activeTab]: {
                [currentSection]: true,
              },
            };
          }
          return prev;
        });
      }
    }
  }, [activeTab, currentSectionIdx, sectionOrder]);

  // Navigation handlers per tab
  const goToPrevSection = () => {
    setCurrentSectionIdx((idxMap) => {
      const idx = idxMap[activeTab] ?? 0;
      return { ...idxMap, [activeTab]: idx > 0 ? idx - 1 : 0 };
    });
  };
  const goToNextSection = () => {
    setCurrentSectionIdx((idxMap) => {
      const idx = idxMap[activeTab] ?? 0;
      return {
        ...idxMap,
        [activeTab]:
          idx < sectionOrder.length - 1 ? idx + 1 : sectionOrder.length - 1,
      };
    });
  };

  // Render a section with accordion
  const renderSection = (
    label: string,
    content: React.ReactNode,
    defaultOpen = false,
  ) => (
    <div style={{ marginBottom: 16 }}>
      <div
        style={{
          cursor: "pointer",
          background: "#f7f7f7",
          padding: "10px 16px",
          borderRadius: "5px",
          fontWeight: "bold",
          border: "1px solid #ddd",
        }}
        onClick={() => toggleSection(label)}
      >
        {label}
        <span style={{ float: "right" }}>
          {(openSections[activeTab]?.[label] ?? defaultOpen) ? "▲" : "▼"}
        </span>
      </div>
      {(openSections[activeTab]?.[label] ?? defaultOpen) && (
        <div style={{ padding: "16px", border: "1px solid #eee" }}>
          {content}
        </div>
      )}
    </div>
  );

  // Example: Render all sections for a person
  const renderTabContent = (tab: string) => {
    // Use the same logic to get the personKey for the current tab
    let personKey: string;
    if (tab === "Primary applicant") {
      personKey = "primary";
    } else if (tab === "Spouse") {
      personKey = "spouse";
    } else if (tab.startsWith("Dependent")) {
      const depNum = tab.split(" ")[1];
      personKey = `dependent${depNum}`;
    } else {
      personKey = "primary";
    }
    const person = people[personKey] || initialPersonData;

    // Helper for input fields
    const input = (
      name: string,
      label: string,
      type: string = "text",
      extraProps: any = {},
    ) => (
      <div style={{ marginBottom: 12 }}>
        <label style={{ width: 220, display: "inline-block" }}>{label}</label>
        <input
          type={type}
          name={name}
          value={person[name] || ""} // Add default empty string
          onChange={(e) => {
            // SIN validation and formatting
            if (name === "sin") {
              let val = e.target.value.replace(/\D/g, "");
              if (val.length > 9) val = val.slice(0, 9);
              // Format as 123-456-789
              let formatted = val;
              if (val.length > 3 && val.length <= 6)
                formatted = `${val.slice(0, 3)}-${val.slice(3)}`;
              else if (val.length > 6)
                formatted = `${val.slice(0, 3)}-${val.slice(3, 6)}-${val.slice(
                  6,
                )}`;
              // Only allow valid SIN format
              handleChange(tab, {
                ...e,
                target: {
                  ...e.target,
                  value: formatted,
                  name: "sin",
                },
              });
            } else {
              handleChange(tab, e);
            }
          }}
          placeholder={
            name === "designation"
              ? "Mr., Mrs., Ms., Dr., etc."
              : name === "sin"
                ? "123-456-789"
                : undefined
          }
          maxLength={name === "sin" ? 11 : undefined}
          pattern={name === "sin" ? "\\d{3}-\\d{3}-\\d{3}" : undefined}
          inputMode={name === "sin" ? "numeric" : undefined}
          {...extraProps}
        />
      </div>
    );

    // Helper for select fields
    const select = (
      name: string,
      label: string,
      options: string[],
      extraProps: any = {},
    ) => (
      <div style={{ marginBottom: 12 }}>
        <label style={{ width: 220, display: "inline-block" }}>{label}</label>
        <select
          name={name}
          value={person[name] || ""} // Add default empty string
          onChange={(e) => handleChange(tab, e)}
          {...extraProps}
        >
          <option value="">Select</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>
    );

    // Map section labels to their renderSection blocks
    const sectionBlocks: { [label: string]: React.ReactNode } = {
      "Tax payer's primary information": renderSection(
        "Tax payer's primary information",
        <>
          {/* Only show Designation for non-Dependent tabs */}
          {!tab.startsWith("Dependent") && input("designation", "Designation")}
          {input("firstName", "First Name")}
          {input("lastName", "Last Name")}
          {/* Only show Relationship for Dependent tabs, and place it below Last Name */}
          {tab.startsWith("Dependent") &&
            select("relationship", "Relationship", [
              "Son",
              "Daughter",
              "Brother",
              "Sister",
              "Niece",
              "Nephew",
              "Aunt",
              "Uncle",
              "Father",
              "Mother",
              "Grandmother",
              "Grandfather",
              "Great grandmother",
              "Great grandfather",
              "Grandson",
              "Granddaughter",
              "Son-in-law",
              "Daughter-in-law",
            ])}
          {input("dob", "Date of Birth", "date")}
          {select("changeOfName", "Change of name for this taxpayer:", [
            "Yes",
            "No",
          ])}
          {input("sin", "Social Insurance Number")}
          {/* ...other fields... */}
        </>,
      ),
      "Situation on December 31, 2026": renderSection(
        "Situation on December 31, 2026",
        <>
          {select("province", "Province of residence on December 31, 2026:", [
            "Alberta",
            "British Columbia",
            "Manitoba",
            "New Brunswick",
            "Newfoundland and Labrador",
            "Nova Scotia",
            "Ontario",
            "Prince Edward Island",
            "Quebec",
            "Saskatchewan",
            "Northwest Territories",
            "Nunavut",
            "Yukon",
          ])}
          {/* Remove maritalStatus for Spouse tab only */}
          {tab !== "Spouse" &&
            select("maritalStatus", "Marital status on December 31, 2026:", [
              "Single",
              "Married",
              "Common-law",
              "Divorced",
              "Separated",
              "Widowed",
            ])}
          {/* 
            - For Dependent tab: show "Did this dependant have any income in 2026?" (Yes/No)
            - For Spouse tab: skip maritalStatusChange
            - For Primary applicant: show maritalStatusChange as before
          */}
          {tab.startsWith("Dependent")
            ? select(
                "dependantHadIncome",
                "Did this dependant have any income in 2026?",
                ["Yes", "No"],
              )
            : tab !== "Spouse" &&
              select(
                "maritalStatusChange",
                "Did your marital status change in 2026 (including separated for less than 90 days):",
                ["Yes", "No"],
              )}
          {/* Remove Gender and How many dependants below 18 years for Dependent tab only */}
          {tab !== "Dependent 1" &&
            tab !== "Dependent 2" &&
            tab !== "Dependent 3" &&
            tab !== "Dependent 4" &&
            tab !== "Dependent 5" &&
            tab !== "Dependent 6" &&
            tab !== "Dependent 7" &&
            tab !== "Dependent 8" &&
            tab !== "Dependent 9" &&
            tab !== "Dependent 10" &&
            select("gender", "Gender (mandatory for Quebec residents):", [
              "Male",
              "Female",
              "Non-binary",
              "Prefer not to say",
            ])}
          {tab === "Spouse"
            ? select(
                "sameAddyAspouse",
                "Do you have the same address as your spouse?",
                ["Yes", "Yes but different phone #", "No"],
              )
            : // Only show "How many dependants below 18 years do you have" if not Dependent tab
              !tab.startsWith("Dependent") &&
              select(
                "dependantsBelow18",
                "How many dependants below 18 years do you have:",
                Array.from({ length: 11 }, (_, i) => i.toString()),
              )}
        </>,
      ),
      "Mailing address and residence information":
        // ...existing code...
        renderSection(
          "Mailing address and residence information",
          <>
            {input("apartmentNumber", "Apartment Number")}
            {input("streetNumber", "Street Number")}
            {input("postOfficeBoxNumber", "Post Office Box Number")}
            {input("ruralRoute", "Rural Route")}
            {input("city", "City")}
            {select("provinceOrTerritory", "Province or Territory:", [
              "Alberta",
              "British Columbia",
              "Manitoba",
              "New Brunswick",
              "Newfoundland and Labrador",
              "Nova Scotia",
              "Ontario",
              "Prince Edward Island",
              "Quebec",
              "Saskatchewan",
              "Northwest Territories",
              "Nunavut",
              "Yukon",
            ])}
            {input("postalCode", "Canadian Postal Code")}
            {input("careOf", "Care of (if applicable)")}
            {input(
              "dom",
              "If your province or territory of residence changed in 2026, enter the date of your move:",
              "date",
            )}
            {select(
              "mailingOrHome",
              "Is your home address the same as your mailing address?:",
              ["Yes", "No"],
            )}
            {input("homePhone", "Home Phone Number")}
            {input("workPhone", "Work Phone Number")}
            {input("cellPhone", "Cellular Phone Number")}
            {select(
              "currProvinceIfd",
              "Current province of residence if different from mailing address:",
              [
                "Alberta",
                "British Columbia",
                "Manitoba",
                "New Brunswick",
                "Newfoundland and Labrador",
                "Nova Scotia",
                "Ontario",
                "Prince Edward Island",
                "Quebec",
                "Saskatchewan",
                "Northwest Territories",
                "Nunavut",
                "Yukon",
              ],
            )}
          </>,
        ),
      "CRA questions": renderSection(
        "CRA questions",
        <>
          {select(
            "corrLanguage",
            "Language of correspondence and of tax return:",
            ["English", "French"],
          )}
          {select(
            "firstTimeFiler",
            "Are you filing an income tax return with the CRA for the very first time?:",
            ["Yes", "No"],
          )}
          {select(
            "forProperty",
            "Did you own foreign property in 2026 with a total cost over CAN $100,000?:",
            ["Yes", "No"],
          )}
          {select(
            "sellPrincipalResidence",
            "Did you sell a principal residence in 2026?:",
            ["Yes", "No"],
          )}
          {select(
            "diplomat",
            "Are you an officer or servant of another country, such as a diplomat, or a family member or an employee of such a person, who were exempt from tax at any time in the taxation year?:",
            ["Yes", "No"],
          )}
          {select("canadianCitizenship", "Do you have Canadian citizenship?:", [
            "Yes",
            "No",
          ])}
          {select(
            "authorizeCra",
            "As a Canadian citizen, do you authorize the Canada Revenue Agency to give your name, address, date of birth, & citizenship to Elections Canada to update the National Register of Electors or, if you are 14 to 17 years of age, the Register of Future Electors?",
            ["Yes", "No"],
          )}
          {select(
            "consentToShare",
            "I authorize the CRA to provide my name and email address to GNWT so that they may contact or send information to me by email about organ and tissue donation. Do you consent to share your contact information?",
            ["Yes", "No"],
          )}
        </>,
      ),
      "Email notifications from CRA": renderSection(
        "Email notifications from CRA",
        <>
          <h3
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
              margin: "10px 0",
            }}
          >
            Terms and conditions
          </h3>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.6",
              marginBottom: "18px",
            }}
          >
            By providing your email address, you are registering for online mail
            and authorizing the CRA to send email notifications when there is
            mail for you to view on My Account. Any notices and correspondence
            delivered online on My Account will be presumed to have been sent on
            the date of that email notification. You understand and agree that
            your notice of assessment and notice of reassessment and any future
            correspondence eligible for online delivery will no longer be
            printed and mailed. Once we have processed your return, CRA will
            send you a registration email notification to the email address you
            have provided. CRA usually processes paper returns in four to six
            weeks and returns filed electronically in as little as eight
            business days. Please add{" "}
            <strong>CRA.DoNotReply-NePasRepondre.ARC@canada.ca</strong> to your
            address book, contact list, or safe senders list.
          </p>
          {select(
            "acceptTerms",
            "I accept the terms and conditions and I choose to receive email notifications from the CRA:",
            ["Yes", "No"],
          )}
          {input("emailAddress", "Email Address", "email", {
            placeholder: "Enter your email",
          })}
          {/* Only show email confirmation if email is present and valid */}
          {person.emailAddress &&
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(person.emailAddress) &&
            select(
              "emailConfirmation",
              "I confirm that the email address above is correct:",
              ["Yes"],
            )}
        </>,
      ),
      "Specific situations": renderSection(
        "Specific situations",
        <>
          <input
            type="text"
            placeholder="Search Specific situations..."
            value={search["Specific situations"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Specific situations"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "specificSituation1",
                label: "Tax return for a deceased person",
              },
              {
                id: "specificSituation2",
                label: "Tax return for a Status Indian",
              },
              { id: "specificSituation3", label: "Prison in 2026" },
              {
                id: "specificSituation4",
                label:
                  "No income to report in the year prior to tax return year",
              },
              {
                id: "specificSituation5",
                label: "You immigrated to Canada in the year prior",
              },
              {
                id: "specificSituation6",
                label: "You emigrated from Canada in the year prior",
              },
              {
                id: "specificSituation7",
                label:
                  "You were a non-resident of Canada for all of the year prior (employment/self-employment/taxable Canadian property income)",
              },
              {
                id: "specificSituation8",
                label:
                  "You were a non-resident of Canada reporting ONLY a disposition of taxable Canadian property (section 116 of ITA)",
              },
              {
                id: "specificSituation9",
                label:
                  "You were a non-resident of Canada for all or part of the year prior reporting ONLY rental income and you are making an election under section 216 of ITA",
              },
              {
                id: "specificSituation10",
                label:
                  "You were a non-resident of Canada for all of the year prior reporting pension income and making an election under section 217 of ITA",
              },
              {
                id: "specificSituation11",
                label:
                  "You are a non-resident of Canada and you wish to file NR6 return.",
              },
              {
                id: "specificSituation12",
                label: "You were a factual resident.",
              },
              {
                id: "specificSituation13",
                label:
                  "You are a Canadian resident and your spouse immigrated to Canada in the year prior.",
              },
              { id: "specificSituation14", label: "Non-resident" },
              { id: "specificSituation15", label: "Deemed non-resident" },
              {
                id: "specificSituation16",
                label: "Deemed resident - stayed 183 days or more in Canada",
              },
              {
                id: "specificSituation17",
                label: "Deemed resident - other reason",
              },
              { id: "specificSituation18", label: "Factual resident" },
            ],
            "Specific situations",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Employment and other benefits": renderSection(
        "Employment and other benefits",
        <>
          <input
            type="text"
            placeholder="Search Employment and other benefits..."
            value={search["Employment and other benefits"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Employment and other benefits"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "employment1",
                label: "T4 - Income earned in any province except Quebec",
              },
              {
                id: "employment2",
                label:
                  "T4 & RL-1(Releve 1) - Income earned in Quebec with QPP contributions",
              },
              {
                id: "employment3",
                label:
                  "T4 & RL-1(Releve 1) - Income earned in Quebec with CPP contributions",
              },
              {
                id: "employment4",
                label: "T4E - Employment Insurance and other benefits",
              },
              { id: "employment5", label: "Tips" },
              { id: "employment6", label: "Other employment imcome" },
              {
                id: "employment7",
                label:
                  "Volunteer firefighters amount and search and rescue volunteers amount",
              },
              {
                id: "employment8",
                label: "CPT20 - CPP Election for other employment earnings",
              },
              {
                id: "employment9",
                label:
                  "CPT20 - CPP Election for tax-exempt self-employment earnings of an Indian (TypeN)",
              },
              {
                id: "employment10",
                label:
                  "T1212 - Statement of deferrred security options benefits",
              },
              {
                id: "employment11",
                label:
                  "T5007 - Workers compensation benefits, social assistance, e.t.c.",
              },
              {
                id: "employment12",
                label: "Union or professional dues not recorded on a T4 slip",
              },
              {
                id: "employment13",
                label: "Mandatory professional liability insurance",
              },
              {
                id: "employment14",
                label:
                  "T777 - Eligible employment expenses for an employee earning a salary",
              },
              {
                id: "employment15",
                label:
                  "T777 - Eligible employment expenses for forestry operations",
              },
              {
                id: "employment16",
                label:
                  "T777 - Eligible employment expenses for a salaried musician",
              },
              {
                id: "employment17",
                label:
                  "T777 - Eligible employment expenses for an apprentice vehicle mechanic, painter, body repairer.",
              },
              {
                id: "employment18",
                label: "T777 - Eligible employment expenses for a tradeperson.",
              },
              {
                id: "employment19",
                label:
                  "TL2 - Eligible meal and lodging expenses (Does not print form TL2)",
              },
              {
                id: "employment20",
                label:
                  "TL2 - Eligible meal and lodging expenses (Prints form TL2)",
              },
              {
                id: "employment21",
                label: "Legal fees paid to collect salary or wages",
              },
              {
                id: "employment22",
                label:
                  "Report income from GST/HST or QST rebates you received in 2025",
              },
              {
                id: "employment23",
                label:
                  "Apply for GST or HST rebate on employment or partnership expenses paid in 2025",
              },
              {
                id: "employment24",
                label: "Other employment/benefit situation",
              },
            ],
            "Employment and other benefits",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Pension, rental, investment": renderSection(
        "Pension, rental, investment",
        <>
          <input
            type="text"
            placeholder="Search Pension, rental, investment..."
            value={search["Pension, rental, investment"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Pension, rental, investment"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "pension1",
                label: "Pension income (T4A, T4A(P), T4A(OIC))",
              },
              {
                id: "pension2",
                label: "Superannuation or pension plan payments",
              },
              { id: "pension3", label: "Foreign pension income" },
              { id: "pension4", label: "Other pension income" },
              { id: "pension5", label: "Rental income (T776, T2121)" },
              {
                id: "pension6",
                label: "Statement of investment income (T3, T5, T5008)",
              },
              { id: "pension7", label: "Foreign investment income" },
              { id: "pension8", label: "Other investment income" },
              {
                id: "pension9",
                label: "Sale of real estate or property (T1255)",
              },
            ],
            "Pension, rental, investment",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Self employment": renderSection(
        "Self employment",
        <>
          <input
            type="text"
            placeholder="Search Self employment..."
            value={search["Self employment"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Self employment"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "selfEmploymentOption1",
                label: "T2125 - Business income.",
              },
              {
                id: "selfEmploymentOption2",
                label: "T2125 - Professional income.",
              },
              {
                id: "selfEmploymentOption3",
                label: "T2125 - Commission income.",
              },
              {
                id: "selfEmploymentOption4",
                label: "T2042 - Farming income (cash basis).",
              },
              {
                id: "selfEmploymentOption5",
                label: "T2042 - Farming income (accrual basis).",
              },
              {
                id: "selfEmploymentOption6",
                label: "Farming was the main source of income.",
              },
              {
                id: "selfEmploymentOption7",
                label: "T2121 - Fishing income.",
              },
              {
                id: "selfEmploymentOption8",
                label:
                  "Schedule 13 - Employment insurance premiums on self-employment & other eligible earmings.",
              },
              {
                id: "selfEmploymentOption9",
                label:
                  "You need to complete the immediate expensing limit agreement.",
              },
              {
                id: "selfEmploymentOption10",
                label:
                  "[67120] - ITC for total qualified ependitures for SR & ED (at 15%).",
              },
              {
                id: "selfEmploymentOption11",
                label:
                  "[67130] - Total contributions made to agricultural organisations for SR & ED (at 15%).",
              },
              {
                id: "selfEmploymentOption12",
                label:
                  "[67140] - ITC for total investments in qualified property (at 10%).",
              },
              {
                id: "selfEmploymentOption13",
                label:
                  "[67170] - ITC for mineral exploration tax credit (METC)(at 15%).",
              },
              {
                id: "selfEmploymentOption14",
                label:
                  "[67175] - ITC for critical mineral exploration tax credit (METC) (at 30%).",
              },
              {
                id: "selfEmploymentOption15",
                label:
                  "[67180] - ITC for apprenticeship job creation tax credit (AJCTC) (at 10%).",
              },
              { id: "selfEmploymentOption16", label: "ITC adjustments." },
              {
                id: "selfEmploymentOption17",
                label: "Limit the current year ITC claim.",
              },
              {
                id: "selfEmploymentOption18",
                label:
                  "[67193] - ITC recapture on SR & ED expensitures at 15%.",
              },
              {
                id: "selfEmploymentOption19",
                label:
                  "[67195] - ITC recapture on SR & ED expenditures at 20%.",
              },
              {
                id: "selfEmploymentOption20",
                label:
                  "[67197] - ITC recapture for child care spaces - if only child care spaces are disposed of.",
              },
              {
                id: "selfEmploymentOption21",
                label:
                  "[67197] - ITC recapture for child care spaces - if property other than child care spaces is disposed of.",
              },
              {
                id: "selfEmploymentOption22",
                label:
                  "[67184] - ITC recapture on SR & ED expenditures at 20% (before 2015).",
              },
              {
                id: "selfEmploymentOption23",
                label:
                  "[67185] - ITC recapture on SR & ED expenditures at 15% (after 2014).",
              },
              {
                id: "selfEmploymentOption24",
                label: "Carry back of investment tax credits to prior years.",
              },
              {
                id: "selfEmploymentOption25",
                label:
                  "Carry forward of investment tax credits from prior years.",
              },
              {
                id: "selfEmploymentOption26",
                label: "Refund of investment tax credits.",
              },
              {
                id: "selfEmploymentOption27",
                label:
                  "You need an Agri stability/AgriInvest (T1163) for a province outside your province of residence.",
              },
            ],
            "Self employment",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Common tax deductions": renderSection(
        "Common tax deductions",
        <>
          <input
            type="text"
            placeholder="Search Common tax deductions..."
            value={search["Common tax deductions"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Common tax deductions"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              { id: "taxDeductionOption1", label: "Medical expenses." },
              {
                id: "taxDeductionOption2",
                label: "Sharing of medical expenses.",
              },
              {
                id: "taxDeductionOption3",
                label: "Last date of medical expenses.",
              },
              {
                id: "taxDeductionOption4",
                label: "Infirmity & disability amount claim for yourself.",
              },
              {
                id: "taxDeductionOption5",
                label:
                  "Disability supports deduction for attendant care, e.t.c. You needed to be able to earn income.",
              },
              {
                id: "taxDeductionOption6",
                label: "Home accesibility expenses.",
              },
              {
                id: "taxDeductionOption7",
                label: "Medical expenses for the dependant.",
              },
              {
                id: "taxDeductionOption8",
                label:
                  "Force transfer of dependants's medical expenses to a parent.",
              },
              {
                id: "taxDeductionOption9",
                label: "Infirmity & disability amounts for the dependant.",
              },
              {
                id: "taxDeductionOption10",
                label:
                  "Disability supports or attendant care needed by the dependant to earn income (line 21500).",
              },
              {
                id: "taxDeductionOption11",
                label:
                  "Canada caregiver amount to claim for this dependant (line 30450).",
              },
              {
                id: "taxDeductionOption12",
                label:
                  "Ontario caregiver amount to claim for this dependant (428 line 58185).",
              },
              {
                id: "taxDeductionOption13",
                label:
                  "Canadian charitable donations (other than per T4 slip & other slips).",
              },
              {
                id: "taxDeductionOption14",
                label: "Gifts to a prescibed university outside Canada.",
              },
              {
                id: "taxDeductionOption15",
                label:
                  "Gifts to the United Nations, its agencies and certain charitable organisations outside Canada.",
              },
              { id: "taxDeductionOption16", label: "Gifts to the government." },
              {
                id: "taxDeductionOption17",
                label: "Gifts of certified cultural property.",
              },
              {
                id: "taxDeductionOption18",
                label: "Gifts of ecologically sensitive land.",
              },
              {
                id: "taxDeductionOption19",
                label: "Gifts to US charities (only with US income).",
              },
              {
                id: "taxDeductionOption20",
                label: "Federal donations or gifts carried forward.",
              },
              {
                id: "taxDeductionOption21",
                label: "Federal political contributions.",
              },
              {
                id: "taxDeductionOption22",
                label:
                  "Sharing donations between spouses & optimization of donations.",
              },
              {
                id: "taxDeductionOption23",
                label: "HBP participation in a RRSP's home buyers plan.",
              },
              {
                id: "taxDeductionOption24",
                label: "LLP participation in a lifelong learning plan.",
              },
              { id: "taxDeductionOption25", label: "FHSA information limit." },
              {
                id: "taxDeductionOption26",
                label:
                  "Contribution to a registered pension plan (RPP) (not on a T4 slip).",
              },
              {
                id: "taxDeductionOption27",
                label:
                  "RC267 - Contributions to a US employer sponsored retirement plan.",
              },
              {
                id: "taxDeductionOption28",
                label:
                  "RC268 - Contributions to a US retirement plan by a commuter from Canada.",
              },
              {
                id: "taxDeductionOption29",
                label:
                  "RC269 - Contributions to a FESPP or to a SSA other than US.",
              },
              {
                id: "taxDeductionOption30",
                label:
                  "T5006 - Registered labour sponsored venture capital corporation.",
              },
              {
                id: "taxDeductionOption31",
                label: "Contributions to the Saskatchewan pension plan.",
              },
              {
                id: "taxDeductionOption32",
                label: "T10 - Pension adjustment reversal.",
              },
            ],
            "Common tax deductions",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Parents & children": renderSection(
        "Parents & children",
        <>
          <input
            type="text"
            placeholder="Search Parents & children..."
            value={search["Parents & children"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Parents & children"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "parentsChildrenOption1",
                label: "Support payments made by you.",
              },
              {
                id: "parentsChildrenOption2",
                label: "Support payments received by you.",
              },
              {
                id: "parentsChildrenOption3",
                label:
                  "Support payments received from a resident of another country.",
              },
              {
                id: "parentsChildrenOption4",
                label: "Universal child care benefits (RC62).",
              },
              {
                id: "parentsChildrenOption5",
                label:
                  "A special situation that allows you to claim childcare expenses even though your earnings are higher than your spouse's.",
              },
              {
                id: "parentsChildrenOption6",
                label: "Adoption expenses for an adopted child.",
              },
              {
                id: "parentsChildrenOption7",
                label: "Daycare (includes day camp).",
              },
              {
                id: "parentsChildrenOption8",
                label: "Camp (dependant stayed overnight).",
              },
              { id: "parentsChildrenOption9", label: "Boarding school." },
              { id: "parentsChildrenOption10", label: "Babysitter." },
            ],
            "Parents & children",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Installments & tax transfer": renderSection(
        "Installments & tax transfer",
        <>
          {/* Page5: Installments & tax transfer */}
          {[
            {
              id: "installmentsTaxTransferOption1",
              label: "Income tax paid by installments.",
            },
          ].map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Carry forward amounts & prior year information": renderSection(
        "Carry forward amounts & prior year information",
        <>
          <input
            type="text"
            placeholder="Search Carry forward amounts & prior year information..."
            value={
              search["Carry forward amounts & prior year information"] || ""
            }
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Carry forward amounts & prior year information"]:
                  e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "carryForwardOption1",
                label: "Non capital losses of other years.",
              },
              {
                id: "carryForwardOption2",
                label: "Restricted farm losses of other years.",
              },
              {
                id: "carryForwardOption3",
                label: "Farming loses of other years.",
              },
              {
                id: "carryForwardOption4",
                label: "Fishing losses of other years.",
              },
              {
                id: "carryForwardOption5",
                label:
                  "Allowable business investment losses (ABIL) of other years.",
              },
              {
                id: "carryForwardOption6",
                label: "Net capital losses of other years.",
              },
              {
                id: "carryForwardOption7",
                label:
                  "Precious or listed personal property losses (LLP) of other years.",
              },
              {
                id: "carryForwardOption8",
                label:
                  "T1A - Request for loss carryback (loss which occured in 2024).",
              },
              {
                id: "carryForwardOption9",
                label: "Alternative minimum tax carry forwards.",
              },
              {
                id: "carryForwardOption10",
                label: "Prior year information (used for installment).",
              },
              {
                id: "carryForwardOption11",
                label:
                  "Line by line prior year comparative information (used for comparative summary).",
              },
            ],
            "Carry forward amounts & prior year information",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Other topics": renderSection(
        "Other topics",
        <>
          <input
            type="text"
            placeholder="Search Other topics..."
            value={search["Other topics"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Other topics"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "otherTopicOption1",
                label:
                  "T1M - Moving expenses deduction (you moved closer to your workplace).",
              },
              {
                id: "otherTopicOption2",
                label:
                  "T1M - Moving expenses deduction (you moved closer to your workplace (simplified method)).",
              },
              {
                id: "otherTopicOption3",
                label: "Unused moving expenses from a prior year.",
              },
              {
                id: "otherTopicOption4",
                label:
                  "Types and amounts of repayment made (Repaid ammounts made to the government or to an employer).",
              },
              { id: "otherTopicOption5", label: "Other deductions." },
              {
                id: "otherTopicOption6",
                label: "T2222 - Northern residents deduction.",
              },
              { id: "otherTopicOption7", label: "Additional deductions." },
              {
                id: "otherTopicOption8",
                label: "Member of the clergy or of a religious order.",
              },
              {
                id: "otherTopicOption9",
                label:
                  "Home buyer's amount for the purchase of a qualifying home.",
              },
              {
                id: "otherTopicOption10",
                label: "Digital news subscription expenses.",
              },
              {
                id: "otherTopicOption11",
                label:
                  "Schedule 12 - multigenerational home renovatio tax credit.",
              },
              {
                id: "otherTopicOption12",
                label: "Eligible educator school supply tax credit.",
              },
              {
                id: "otherTopicOption13",
                label:
                  "T1 - ADJ - Adjustment request of federal tax return for 2018 or a previous year.",
              },
              {
                id: "otherTopicOption14",
                label:
                  "TP - 1.R - Adjustment request of Quebec tax return for 2024 or a previous year.",
              },
            ],
            "Other topics",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Other income": renderSection(
        "Other income",
        <>
          <input
            type="text"
            placeholder="Search Other income..."
            value={search["Other income"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Other income"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "otherIncomeOption1",
                label: "Labour adjustment benefits.",
              },
              {
                id: "otherIncomeOption2",
                label: "Grants or training allowance.",
              },
              {
                id: "otherIncomeOption3",
                label:
                  "Death benefit received from employer upon death of your spouse.",
              },
              {
                id: "otherIncomeOption4",
                label: "T1198 - Qualifying retroactive lump-sum payment.",
              },
              { id: "otherIncomeOption5", label: "Other taxable income." },
            ],
            "Other income",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}
        </>,
      ),
      "Other information slips": renderSection(
        "Other information slips",
        <>
          <input
            type="text"
            placeholder="Search Other information slips..."
            value={search["Other information slips"] || ""}
            onChange={(e) =>
              setSearch((prev) => ({
                ...prev,
                ["Other information slips"]: e.target.value,
              }))
            }
            style={{
              marginBottom: 12,
              padding: "8px",
              width: "100%",
              maxWidth: 400,
              fontSize: "1rem",
            }}
          />
          {filterItems(
            [
              {
                id: "otherInfoSlipOption1",
                label:
                  "RC210 - Canada workers benefit advance payments statement.",
              },
            ],
            "Other information slips",
          ).map((item) => (
            <div key={item.id} style={{ marginBottom: 8 }}>
              <input
                type="checkbox"
                name={item.id}
                checked={!!person[item.id]}
                onChange={(e) => handleChange(tab, e)}
                id={item.id}
              />
              <label htmlFor={item.id} style={{ marginLeft: 8 }}>
                {item.label}
              </label>
            </div>
          ))}

          {tab === "Primary applicant" && (
            <div
              style={{
                marginTop: 24,
                padding: 20,
                border: "1px solid #ddd",
                borderRadius: 8,
                background: "#fafafa",
              }}
            >
              <h3 style={{ marginBottom: 12, fontSize: "1.2rem" }}>
                DOCEX Tax Corp Privacy Assurance Acknowledgement
              </h3>

              <div style={{ marginBottom: 16 }}>
                <button
                  type="button"
                  onClick={() =>
                    setOpenSections((prev) => ({
                      ...prev,
                      [activeTab]: {
                        ...prev[activeTab],
                        privacyPolicy: !prev[activeTab]?.privacyPolicy,
                      },
                    }))
                  }
                  style={{
                    padding: "10px 16px",
                    borderRadius: 6,
                    border: "1px solid #007BFF",
                    background: "#fff",
                    color: "#007BFF",
                    cursor: "pointer",
                    fontWeight: 600,
                  }}
                >
                  {openSections[activeTab]?.privacyPolicy
                    ? "Hide privacy policy"
                    : "Read privacy policy"}
                </button>
              </div>

              {openSections[activeTab]?.privacyPolicy && (
                <div
                  style={{
                    marginBottom: 18,
                    padding: 16,
                    background: "#fff",
                    border: "1px solid #e0e0e0",
                    borderRadius: 8,
                    lineHeight: 1.6,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  DOCEX Tax Corp. Privacy Assurance Your Privacy is Important to
                  Us. At DOCEX Tax Corp., protecting your personal information
                  is a fundamental part of our commitment to delivering
                  professional tax preparation and advisory services. This
                  Privacy Assurance explains how we collect, use, disclose,
                  protect, and retain your personal information in accordance
                  with applicable Canadian privacy laws, including PIPEDA. What
                  we collect. Depending on the services you request, we may
                  collect identification and contact information, tax and
                  financial records, banking information for direct deposit,
                  supporting tax documents, and information you provide during
                  consultations or through our website. How we use your
                  information. Your information is used to prepare and file tax
                  returns, communicate with you, verify your identity, respond
                  to inquiries, process payments or refunds, improve our
                  services, comply with legal obligations, and protect against
                  fraud. Disclosure of information. We do not sell your personal
                  information. Information is shared only with trusted service
                  providers, government agencies where required by law, or with
                  your consent. Security. DOCEX Tax Corp. uses administrative,
                  physical, and technical safeguards including restricted
                  access, encryption where appropriate, secure storage, and
                  staff confidentiality obligations. Retention. We retain
                  personal information only as long as necessary to fulfill
                  legal, regulatory, and business requirements. Information is
                  securely destroyed or anonymized when no longer required. Your
                  Rights. You may request access to your personal information,
                  request corrections, withdraw consent where permitted by law,
                  or submit privacy concerns to our Privacy Officer. Contact
                  Information. Privacy Officer DOCEX Tax Corp. Email:
                  docexcorp@gmail.com Website: www.docextax.com
                </div>
              )}

              <div style={{ marginBottom: 16 }}>
                <label
                  htmlFor="privacyPolicyAcknowledged"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    id="privacyPolicyAcknowledged"
                    name="privacyPolicyAcknowledged"
                    checked={Boolean(person.privacyPolicyAcknowledged)}
                    onChange={(e) => handleChange(tab, e)}
                    style={{ marginRight: 10 }}
                  />
                  I acknowledge that I have received and reviewed the DOCEX Tax
                  Corp. Privacy Assurance and consent to the collection, use,
                  and disclosure of my personal information as described herein.
                </label>
              </div>

              <div style={{ marginBottom: 16 }}>
                <label
                  htmlFor="privacyPolicyReadDate"
                  style={{ display: "block", marginBottom: 8 }}
                >
                  Date
                </label>
                <input
                  type="date"
                  id="privacyPolicyReadDate"
                  name="privacyPolicyReadDate"
                  value={person.privacyPolicyReadDate || ""}
                  onChange={(e) => handleChange(tab, e)}
                  style={{
                    padding: "10px",
                    width: "100%",
                    maxWidth: 280,
                    borderRadius: 6,
                    border: "1px solid #ccc",
                  }}
                />
              </div>

              <div>
                <label
                  htmlFor="privacyPolicyFullName"
                  style={{ display: "block", marginBottom: 8 }}
                >
                  Full name (print)
                </label>
                <input
                  type="text"
                  id="privacyPolicyFullName"
                  name="privacyPolicyFullName"
                  value={person.privacyPolicyFullName || ""}
                  onChange={(e) => handleChange(tab, e)}
                  placeholder="Enter your full name"
                  style={{
                    padding: "10px",
                    width: "100%",
                    maxWidth: 420,
                    borderRadius: 6,
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </div>
          )}
        </>,
      ),
    };

    // Only render the current section for the current tab
    const idx = currentSectionIdx[tab] ?? 0;
    const currentSectionLabel = sectionOrder[idx];

    return (
      <div>
        {sectionBlocks[currentSectionLabel]}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 24,
          }}
        >
          <button
            onClick={goToPrevSection}
            disabled={idx === 0}
            style={{
              padding: "10px 24px",
              fontSize: "1rem",
              borderRadius: "5px",
              backgroundColor: idx === 0 ? "#ccc" : "#007BFF",
              color: "#fff",
              border: "none",
              cursor: idx === 0 ? "not-allowed" : "pointer",
              opacity: idx === 0 ? 0.6 : 1,
            }}
          >
            Previous
          </button>
          <button
            onClick={goToNextSection}
            disabled={idx === sectionOrder.length - 1}
            style={{
              padding: "10px 24px",
              fontSize: "1rem",
              borderRadius: "5px",
              backgroundColor:
                idx === sectionOrder.length - 1 ? "#ccc" : "#007BFF",
              color: "#fff",
              border: "none",
              cursor:
                idx === sectionOrder.length - 1 ? "not-allowed" : "pointer",
              opacity: idx === sectionOrder.length - 1 ? 0.6 : 1,
            }}
          >
            Next
          </button>
        </div>
      </div>
    );
  };

  // Add Dependent button
  const addDependent = () => {
    const newCount = dependantsCount + 1;
    setPeople((prev) => ({
      ...prev,
      [`dependent${newCount}`]: { ...initialPersonData },
      primary: { ...prev.primary, dependantsBelow18: newCount.toString() },
    }));
  };

  // Delete Dependent button
  const deleteDependent = () => {
    console.log("deleteDependent clicked");
    console.log("activeTab is", activeTab);
    console.log("dependantsCount is", dependantsCount);

    if (dependantsCount > 0) {
      // Calculate which dependent will be removed
      const dependentLabel = `Dependent ${dependantsCount}`;

      // If you are currently on the dependent you’re about to delete,
      // switch tabs *first* before state updates
      if (activeTab === dependentLabel) {
        console.log(`Switching from ${activeTab} to Primary applicant`);
        setActiveTab("Primary applicant");
      }

      // Then remove it from people state
      setPeople((prev) => {
        const updated = { ...prev };
        delete updated[`dependent${dependantsCount}`];
        return {
          ...updated,
          primary: {
            ...updated.primary,
            dependantsBelow18: (dependantsCount - 1).toString(),
          },
        };
      });
    }
  };

  // Add search state for each section (move this above renderTabContent)
  const [search, setSearch] = useState<{ [section: string]: string }>({});

  // Helper to filter items by search term
  const filterItems = (
    items: { id: string; label: string }[],
    section: string,
  ) =>
    items.filter((item) =>
      (search[section] || "")
        .toLowerCase()
        .split(" ")
        .every((word) => item.label.toLowerCase().includes(word)),
    );

  // Add a state for submit loading
  const [submitting, setSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState<string | null>(null);

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    void submitApplication();
  };

  const submitApplication = async (): Promise<void> => {
    if (submitting) {
      return;
    }

    setSubmitting(true);
    setSubmissionError(null);
    localStorage.removeItem("contactInfoSubmitted");

    try {
      const taxSessionId = await createTaxSession();

      const primaryPerson = await createPerson(taxSessionId, "PRIMARY");
      const primaryPersonId = primaryPerson.personId;

      const primaryApplicantData = buildApplicantPayload(
        { ...people.primary, role: "PRIMARY" },
        "PRIMARY",
      );
      await updatePerson(primaryPersonId, primaryApplicantData);

      const primaryCraQuestions = buildCraQuestionPayload(people.primary);
      await saveCraQuestions(primaryPersonId, primaryCraQuestions);

      const primaryCheckboxData = buildPersonCheckboxPayload(people.primary);
      console.log("Primary checkbox/privacy payload:", primaryCheckboxData);

      await savePersonCheckboxes(primaryPersonId, primaryCheckboxData);

      const shouldCreateSpouse =
        people.primary.maritalStatus === "Married" ||
        people.primary.maritalStatus === "Common-law";

      if (shouldCreateSpouse && people.spouse) {
        const spousePerson = await createPerson(taxSessionId, "SPOUSE");
        const spousePersonId = spousePerson.personId;

        const spouseApplicantData = buildApplicantPayload(
          { ...people.spouse, role: "SPOUSE" },
          "SPOUSE",
        );
        await updatePerson(spousePersonId, spouseApplicantData);

        const spouseCraQuestions = buildCraQuestionPayload(people.spouse);
        await saveCraQuestions(spousePersonId, spouseCraQuestions);

        const spouseCheckboxData = buildPersonCheckboxPayload(people.spouse);
        await savePersonCheckboxes(spousePersonId, spouseCheckboxData);
      }

      const dependantEntries = Object.entries(people).filter(([key]) =>
        key.startsWith("dependent"),
      );

      for (const [, dependantPerson] of dependantEntries) {
        const dependant = await createPerson(taxSessionId, "DEPENDANT");
        const dependantPersonId = dependant.personId;

        const dependantApplicantData = buildApplicantPayload(
          {
            ...(dependantPerson as Record<string, unknown>),
            role: "DEPENDANT",
          },
          "DEPENDANT",
        );
        await updatePerson(dependantPersonId, dependantApplicantData);

        const dependantCraQuestions = buildCraQuestionPayload(
          dependantPerson as Record<string, unknown>,
        );
        await saveCraQuestions(dependantPersonId, dependantCraQuestions);

        const dependantCheckboxData = buildPersonCheckboxPayload(
          dependantPerson as Record<string, unknown>,
        );
        await savePersonCheckboxes(dependantPersonId, dependantCheckboxData);
      }

      /*
       * Do not submit contact information from Home.tsx.
       *
       * Success.tsx collects the destination email and performs
       * the final contact/email submission.
       */
      localStorage.setItem("taxSessionId", String(taxSessionId));

      localStorage.setItem("personId_PRIMARY", String(primaryPersonId));

      /*
       * Clear the submission marker for this newly created
       * tax session.
       */
      localStorage.removeItem("contactInfoSubmittedSessionId");

      history.push("/success", {
        taxSessionId,
      });
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Unknown submission error";
      console.error("Application submission failed:", error);
      setSubmissionError(message);
      alert(`Submission failed: ${message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        fontFamily: "'Poppins', sans-serif",
        background: "linear-gradient(135deg, #f5f6fa 0%, #e9ecef 100%)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          background: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
          padding: "24px 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 32px",
          }}
        >
          <span
            style={{
              fontWeight: 700,
              fontSize: "1.7rem",
              color: "#0a0a23",
              letterSpacing: "1px",
            }}
          >
            DOCEX TAX
          </span>
          <nav>
            <Link
              to="/"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Home
            </Link>
            <Link
              to="/home"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Apply
            </Link>
            <Link
              to="#"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Additional Info
            </Link>
            <Link
              to="#"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Income
            </Link>
            <Link
              to="#"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Deductions
            </Link>
            <Link
              to="#"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Other
            </Link>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main style={{ flex: 1, width: "100%", margin: "0 auto" }}>
        {/* Tab Navigation */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 24,
            marginTop: 32,
          }}
        >
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                padding: "10px 30px",
                fontSize: "1rem",
                borderRadius: "5px 5px 0 0",
                border:
                  activeTab === tab ? "2px solid #007BFF" : "1px solid #ccc",
                backgroundColor: activeTab === tab ? "#fff" : "#f0f0f0",
                color: activeTab === tab ? "#007BFF" : "#333",
                marginRight: 2,
                outline: "none",
                cursor: "pointer",
                borderBottom: activeTab === tab ? "none" : "1px solid #ccc",
              }}
            >
              {tab}
            </button>
          ))}
          {/* Add Dependent Button */}
          <button
            onClick={addDependent}
            style={{
              marginLeft: 10,
              padding: "10px 20px",
              fontSize: "1rem",
              borderRadius: "5px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              height: 44,
            }}
          >
            + Add Dependent
          </button>
          {/* Delete Dependent Button */}
          <button
            onClick={deleteDependent}
            disabled={dependantsCount === 0}
            style={{
              marginLeft: 10,
              padding: "10px 20px",
              fontSize: "1rem",
              borderRadius: "5px",
              backgroundColor: dependantsCount === 0 ? "#ccc" : "#dc3545",
              color: "#fff",
              border: "none",
              cursor: dependantsCount === 0 ? "not-allowed" : "pointer",
              height: 44,
              opacity: dependantsCount === 0 ? 0.6 : 1,
            }}
            title="Delete last dependent"
          >
            Delete Dependent
          </button>
        </div>
        {/* Tab Content */}
        <div
          style={{
            border: "2px solid #007BFF",
            borderRadius: "0 0 8px 8px",
            padding: "30px 20px",
            maxWidth: 700,
            margin: "0 auto 30px auto",
            background: "#fff",
          }}
        >
          {renderTabContent(activeTab)}
        </div>
        {/* Consolidated Submit Button */}
        <form onSubmit={handleFormSubmit}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "30px 0 0 0",
            }}
          >
            <button
              type="submit"
              disabled={submitting}
              style={{
                padding: "12px 40px",
                fontSize: "1.1rem",
                borderRadius: "6px",
                backgroundColor: "#007BFF",
                color: "#fff",
                border: "none",
                cursor: submitting ? "not-allowed" : "pointer",
                fontWeight: 600,
                opacity: submitting ? 0.7 : 1,
              }}
            >
              {submitting ? "Submitting..." : "Submit All"}
            </button>
          </div>
        </form>
      </main>

      {/* Footer */}
      <footer
        style={{
          background: "#f5f6fa",
          padding: "24px 0",
          textAlign: "center",
          color: "#888",
          fontSize: "1rem",
          borderTop: "1px solid #eee",
        }}
      >
        <div>
          &copy; {new Date().getFullYear()} DOCEX Tax. All rights reserved.
        </div>
        <div style={{ marginTop: 8 }}>
          <Link to="/" style={{ color: "#007BFF", margin: "0 10px" }}>
            Home
          </Link>
          <Link to="/home" style={{ color: "#007BFF", margin: "0 10px" }}>
            Apply
          </Link>
          <Link to="#" style={{ color: "#007BFF", margin: "0 10px" }}>
            Additional Info
          </Link>
          <Link to="#" style={{ color: "#007BFF", margin: "0 10px" }}>
            Income
          </Link>
          <Link to="#" style={{ color: "#007BFF", margin: "0 10px" }}>
            Deductions
          </Link>
          <Link to="#" style={{ color: "#007BFF", margin: "0 10px" }}>
            Other
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Home;
